import React from "react";

const CARD_WIDTH = 300;

// Every always-visible preview occupies this footprint, whatever width and height
// its mockup is authored at, so the permission list reads as an even grid of tiles.
const PREVIEW_WIDTH = 120;
const PREVIEW_HEIGHT = 85;

interface ScaledThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
  /**
   * Intrinsic width the mockup is authored at. Wide layouts (tables, multi-column
   * screens) need more room than CARD_WIDTH or their content clips, so they are
   * authored wider and shown at native width on hover.
   */
  contentWidth?: number;
  children: React.ReactNode;
}

/**
 * Shared wrapper for the admin permission thumbnails. A CSS transform does not
 * change the layout box, so the always-visible wrapper is given the preview box
 * dimensions and clips whatever falls below it. Hover pop-outs render at native size.
 */
export function ScaledThumbnail({
  isHovered = false,
  alwaysVisible = false,
  contentWidth = CARD_WIDTH,
  children,
}: ScaledThumbnailProps) {
  if (!alwaysVisible) {
    return (
      <div className={isHovered ? "z-50" : "z-0"}>
        <div style={{ width: contentWidth }}>{children}</div>
      </div>
    );
  }

  return (
    <div
      className={`${isHovered ? "z-50" : "z-0"} overflow-hidden rounded-md`}
      style={{ width: PREVIEW_WIDTH, height: PREVIEW_HEIGHT }}
    >
      <div
        className="origin-top-left"
        style={{
          width: contentWidth,
          transform: `scale(${PREVIEW_WIDTH / contentWidth})`,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default ScaledThumbnail;
